<template>
    <div class="home">
        <p class="blocksatz_c">
            You want to buy a print or an original? Or you are interested and want to ask questions about my work? Just write me via email or instagram:
        </p>
        <p class="blocksatz_c">
            <br />
            <a href="mailto:lunartic.online@gmail.com">Email</a><br />
            <a href="https://www.instagram.com/lunartic.kleiner_mond/" target="_blank">Instagram</a>
        </p>
    </div>
</template>

<script>
    import store from "@/store";
    export default {
        name: 'Contact',
        data: function () {
            return {
                store: store
            };
        },
        components: {
        }
    }
</script>

<style scoped>
    a {
        font-weight: bold;
        text-decoration: underline;
    }

        a:hover {
            text-decoration: none;
        }

    p {
        font-size: 26px;
        line-height: 34px;
    }

    @media screen and (max-width: 768px) {
        p {
            font-size: 22px;
            line-height: 30px;
        }
    }

    .blocksatz_c {
        hyphens: auto;
        text-align: justify; /* f�r Edge */
        -moz-text-align-last: center; /* f�r Firefox vor 58.0 */
        text-align-last: center;
        max-width: 1024px;
        margin: 0 auto;
    }
</style>
